import { FieldValues } from 'react-hook-form';
import { RefinementCtx, z } from 'zod';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { IS_VALID_URL } from 'utils/validationRegex';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../types';

const { API_ENDPOINT, ESP, NAME, API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const refineApiEndpoint = (values: FieldValues, ctx: RefinementCtx) => {
  const { [ESP]: esp, [API_ENDPOINT]: apiEndpoint } = values;
  if (esp !== SERVICE_PROVIDERS.SPARKPOST_ELITE) return;
  if (!apiEndpoint) {
    ctx.addIssue({
      message: 'Enter a custom endpoint URL.',
      code: z.ZodIssueCode.custom,
      path: [API_ENDPOINT],
    });
  } else if (apiEndpoint && !apiEndpoint.match(IS_VALID_URL)) {
    ctx.addIssue({
      message: 'Enter a valid URL.',
      code: z.ZodIssueCode.custom,
      path: [API_ENDPOINT],
    });
  }
};

export const refineIterableSmsFields = (values: FieldValues, ctx: RefinementCtx) => {
  const { [ESP]: esp, [API_ENDPOINT]: apiEndpoint, [NAME]: name, [API_KEY]: apiKey } = values;
  const isTwilio = esp === SERVICE_PROVIDERS.TWILIO;

  if (!name) {
    const message = isTwilio ? 'Enter an API key SID' : 'Enter a name';
    ctx.addIssue({
      message,
      code: z.ZodIssueCode.custom,
      path: [NAME],
    });
  } else if (!apiKey) {
    const message = isTwilio ? 'Enter an API key secret' : 'Enter an API key';
    ctx.addIssue({
      message,
      code: z.ZodIssueCode.custom,
      path: [API_KEY],
    });
  } else if (isTwilio && !apiEndpoint) {
    ctx.addIssue({
      message: 'Enter an Account SID',
      code: z.ZodIssueCode.custom,
      path: [API_ENDPOINT],
    });
  }
};
